<template>
  <header id="unum-header" class="unum-header">
    <div class="unum-header__left">
      <a @click.prevent="logoClickEvent" href="#" class="logo" :tabindex="'1'">Colonial Life EPS</a>
    </div>
    <div class="unum-header__right">
      <button
        v-if="$route.name === 'Compare' || $route.name === 'Final' || $route.name === 'FinalSelection'"
        class="print-button"
        @click="print()"
      >Print</button>
      <h1 class="app-title">Tech Platform Assistant</h1>
      <!--
      <transition name="fade" mode="out-in">
        <p
          v-if="!session && this.$route.name === 'Session'"
          @click.prevent="logoutSession"
          class="session-info session-info--logout"
        >
          Logout
        </p>
        <p
          v-else
          class="session-info"
        >
          <strong>Case Name:</strong> {{ session.caseName }} |
          <strong>Case Size:</strong> {{ session.caseSize }}
        </p>
      </transition>
      -->
      <transition name="fade" mode="out-in">
        <button
          class="menu-toggle"
          @click.stop="toggleDrawerEvent"
        >
          Toggle Menu
        </button>
      </transition>
    </div>
  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import sessionEvent from '@/util/sessionEvent'

export default {
  name: 'UnumHeader',
  methods: {
    ...mapActions('shared', [
      'toggleDrawer'
    ]),
    ...mapActions('user', [
      'logout'
    ]),
    logoutSession () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_header_logout')
      this.logout()
    },
    toggleDrawerEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_drawer_open', this.$store.state.route)
      this.toggleDrawer()
    },
    logoClickEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_header_logo', this.$store.state.route)
      this.$router.push({name: 'Home'})
    },
    print () {
      window.print()
    }
  },
  computed: {
    ...mapState('user', [
      'session'
    ])
  },
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.unum-header {
  height: 8rem;
  padding: 3rem 2rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: $blueGrey;
  background-color: $steelblue3;
  background-repeat: no-repeat;
  background-position: right 10px top 10px;
  background-size: auto 70%;

  @include bp($medium) {
    align-items: stretch;
    height: 5rem;
    padding: 1rem 2rem;
  }

  @media print {
    height: 5rem;
    background-image: url('~@/assets/images/bg-header-right.svg');
  }

  &__right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media print {
      display: none;
    }
  }
}

.logo {
  transition: all .25s ease;
  background: url('~@/assets/images/brand/logo.svg') center center no-repeat;
  background-size: contain;
  width: 10rem;
  height: 2.625em;
  display: block;
  text-indent: -9999px;

  &:focus,
  &:hover {
    outline: 0;
    transform: scale(1.05);
  }
}

.menu-toggle {
  margin-left: 2rem;
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background: url('~@/assets/images/ui/hamburger.svg') center center no-repeat;
  background-size: contain;
  width: 2.5rem;
  height: 1.5rem;

  @include bp($large) {
    width: 45px;
    height: 25px;
  }
  cursor: pointer;
}

.app-title {
  font-size: 1rem;
  margin: 0 2rem 0 0;
  position: absolute;
  top: 1.5rem;
  right: 0;
  @include bp($medium) {
    position: static;
    top: auto;
    right: auto;
    margin: 0;
  }
}

.session-info {
  display: none;
  margin: 0;
  background: rgba(0, 0, 0, .15);
  padding: .5rem 1.5rem;
  border-radius: 10rem;
  @include bp($small) {
    display: block;
  }

  &--logout {
    cursor: pointer;
    display: block;

    &:hover {
      color: #fff;
    }
  }
}

.print-button {
  cursor: pointer;
  display: inline-block;
  padding: rem(5px) rem(10px) rem(5px) rem(32px);
  color: $blue;
  font-family: $barlow;
  font-weight: bold;
  font-size: rem(14px);
  border: 0;
  border-radius: rem(3px);
  background-color: #FFF;
  background-repeat: no-repeat;
  background-position: 9px center;
  background-size: 12px auto;
  background-image: url('~@/assets/images/ui/icon-print-blue.svg');
  transition: background-color 0.3s;
  &:hover {
    background-color: #EEE;
  }
  @include bp($medium) {
    margin: 0 rem(30px) 0 0;
    background-position: 11px center;
    background-size: 16px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue